import NextTranslateTrans from 'next-translate/Trans'

const Trans = (props) => (
  <NextTranslateTrans {...props} i18nKey={`common:${props.i18nKey}`} />
)

export default Trans
